.bottom-row > div {
    align-items: center;
}
